module.exports = __webpack_public_path__ + "static/image/service/pc/takeout.ver2_0_2.jpg?8251ab7a";